module.exports = __webpack_public_path__ + "img/co.a14070a7.png";